import React, { FC } from 'react';
import Chart from 'react-apexcharts';

import { Maybe } from 'interfaces/graphql-typings';
import {
  CombinedMonthlyResults,
  PollResultKeys
} from 'buyside/components/container/CompanyShow/pollResultsUtil';

const PollingChart: FC<{
  columns: CombinedMonthlyResults[];
  questionId: string;
  tickCount: number;
  tickFormat: Maybe<string[]>;
  tooltipShow: boolean;
  yMax: Maybe<number>;
  yMin: Maybe<number>;
}> = ({ columns, questionId, tickCount, tickFormat, tooltipShow, yMax, yMin }) => {
  const { data } = columns.reduce(
    (
      result: {
        data: {
          [PollResultKeys.buyside]: { x: string; y: Maybe<string> }[];
          [PollResultKeys.retail]: { x: string; y: Maybe<string> }[];
        };
      },
      column
    ) => {
      const month = column.name;

      result.data[PollResultKeys.buyside].push({
        x: month,
        y: column[PollResultKeys.buyside] || null
      });
      result.data[PollResultKeys.retail].push({
        x: month,
        y: column[PollResultKeys.retail] || null
      });

      return result;
    },
    {
      data: {
        [PollResultKeys.buyside]: [],
        [PollResultKeys.retail]: []
      }
    }
  );

  return (
    <Chart
      type="line"
      height={300}
      series={[
        {
          name: PollResultKeys.buyside,
          data: data[PollResultKeys.buyside]
        },
        {
          name: PollResultKeys.retail,
          data: data[PollResultKeys.retail]
        }
      ]}
      options={{
        colors: ['#326299', '#7DB9FF', '#4A90E2', '#AEC7E3', '#7696BC'],
        chart: {
          fontFamily: 'Lato',
          type: 'line',
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          }
        },
        tooltip: {
          // do not show values for Poll Question #1 (1 (Bearish) / 2 (Neutral) / 3(Bearish))
          enabled: tooltipShow && questionId !== '1',
          y: {
            formatter: (val): string => {
              if (!val) return 'No Data';
              return val.toFixed(1);
            }
          }
        },
        markers: {
          size: 4
        },
        stroke: {
          width: 2
        },
        yaxis: {
          min: yMin || undefined,
          max: yMax || undefined,
          tickAmount: tickCount - 1,
          showForNullSeries: false,
          labels: {
            formatter: (val): string => {
              return tickFormat ? tickFormat[val - 1] : val.toFixed(0);
            }
          }
        },
        xaxis: {
          type: 'category'
        }
      }}
    />
  );
};

export default PollingChart;
